// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;

//resize sizes
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;
resizeWindow();


(function(){

	//booking cta show
	document.getElementsByClassName('js-booking-cta')[0].addEventListener('click', function(){
		if(!document.getElementById('bookingBox').classList.contains('open')){
			document.getElementById('bookingBox').classList.add('open');
			this.innerHTML = 'Close';
			document.getElementById('bookingBox').addEventListener('click', checkOutBooking);
		} else {
			document.getElementById('bookingBox').classList.remove('open');
			this.innerHTML = 'Reserve';
			document.getElementById('bookingBox').removeEventListener('click', checkOutBooking);
		}
	});
	document.getElementById('closeBooking').addEventListener('click', function(){
		document.getElementById('bookingBox').classList.remove('open');
		document.getElementsByClassName('js-booking-cta')[0].innerHTML = 'Reserve';	
	});


	//columns tags
	if(document.getElementsByClassName('columns-filter').length > 0){
		let allColumns = document.getElementsByClassName('columns');
		let allColumnsLength = allColumns.length;

		//creating the filter
		let newList = document.createElement('ul');
		let newLabel = document.createElement('div');
		newLabel.classList.add('label');
		// newLabel.innerHTML = 'Enrich your';
		document.getElementById('columns-filter').appendChild(newLabel);
		for(let i =0; i < allColumnsLength; i++){
			let newli = document.createElement('li');
			newli.innerHTML = '<a class="tag-link" href="#column-'+ allColumns[i].getAttribute('data-tag') +'">'+ allColumns[i].getAttribute('data-tag') +'</a>';
			newList.appendChild(newli);
		}
		document.getElementById('columns-filter').appendChild(newList);
		let allLinks = document.getElementsByClassName('tag-link');
		for(let j = 0; j < allLinks.length; j++){
			allLinks[j].addEventListener('click',function(e){
				e.preventDefault();
				animateTo(this.getAttribute('href').split('#')[1]);
			});
		}
	}

	//check slider after list 
	if(document.getElementsByClassName('list-block').length){
		let allListblocks = document.getElementsByClassName('list-block');
		for(let y = 0; y < allListblocks.length; y++){
			if(allListblocks[y].nextElementSibling){
				if(allListblocks[y].nextElementSibling.classList.contains('slider-block')){
					allListblocks[y].classList.add('nextslider')
				}
			}
			
		}
	}

	// RESTAURANT MENUS FILTER
	document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.restMenus_item').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});
	

	$(document).ready(function () {

		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start)
		})
		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end)
		})
		//alert($('#arriveInput').val());

		$('.calendar-block').datepicker({
			changeMonth: true,
			dateFormat: 'mm-dd-yy',
			numberOfMonths: 1,
			//altField: "#arriveInput",
			//altFormat: "mm-dd-yy",
			afterShow: function() {
				setTimeout(function() {
					document.querySelectorAll('.ui-datepicker td a').forEach(e => {
						e.setAttribute('tabindex', '-1');
					})
				}, 1000);
			},	
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "mm-dd-yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				//console.log(start);
				//console.log(end);

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);
			
			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});

		var form_field = $('.form-module__field--unit');

		form_field.find('input').attr('aria-expanded', 'false');
		
		
	});

	window.onload = function() {
		if(document.getElementById('home')){
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		} else {
			document.getElementById('header').classList.add('down');
		}
		resizeWindow();
		window.addEventListener('resize', function(){
			resizeWindow();
		});
		if(windowWidth < 700 || windowWidth > 1190){
			//home video
			if(document.getElementById('homeVideo')){
				let homevideo = document.getElementById('homeVideo');
				setTimeout(() => {
					// it's loaded
					homevideo.play();
				}, 1500);
			}
		}
		
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	//header image to be window height on homepage
	
	if(document.getElementsByClassName('big-image').length > 0){
		
		let headerImages = document.getElementsByClassName('big-image');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			if(document.getElementById('home')){
				headerImages[i].style.height = (windowHeight + 5) + 'px';
			} else {
				headerImages[i].style.height = '420px';
			}
		}
		
	}
	
	if(windowWidth < 1000){
		document.getElementById('primary-nav').classList.add('tablet-view');
	}
	
}
//click event for booking
function checkOutBooking(e){
	let parentBooking = document.getElementById('bookingBox');
	if(e.target == parentBooking){
		document.getElementById('bookingBox').classList.remove('open');
		document.getElementsByClassName('js-booking-cta')[0].innerHTML = 'Reserve';	
	}
}
